// <<<<<<<--------------------------------------------------------------------------------------Notificatiob ------------------------------->>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import {
  Button,
  Table,
  Select,
  Row,
  Col,
  Input,
  Popconfirm,
  Modal,
  Switch,
  Tag,
} from "antd";
import { useTranslation } from "react-i18next";
import { API_LIST_USER } from "api/user-mangement";
import { CONSTANTS } from "config/constant";
import { API_CREATE_NOTIFICATION } from "api/Notification-management";
import { toast } from "react-toastify";
import { API_LIST_NOTIFICATIONS } from "api/Notification-management";
import userplace from "../../../assets/img/orders/orderDetail/userplace.png";

const { Option } = Select;

// Mock data for initial notifications
const initialNotifications = [
  {
    key: "1",
    title: "Order Confirmed",
    message: "Your order has been confirmed.",
    enabled: true,
  },
  {
    key: "2",
    title: "Order Placed",
    message: "Your order has been placed.",
    enabled: true,
  },
  {
    key: "3",
    title: "Driver Assigned",
    message: "A driver has been assigned to your order.",
    enabled: true,
  },
];

// Mock data for users
const initialData = [
  {
    key: "1",
    name: "Mukubwe Njongo",
    phoneNumber: "012345671011",
    email: "muksgo@gmail.com",
    deviceType: "Android",
    role: "Store",
  },
  {
    key: "2",
    name: "mazin",
    phoneNumber: "9079283098",
    email: "tama26zee@gmail.com",
    deviceType: "iOS",
    role: "Driver (Truck)",
  },
  {
    key: "3",
    name: "Test",
    phoneNumber: "012354546",
    email: "liton833.mh@gmail.com",
    deviceType: "Android",
    role: "Driver (Car)",
  },
  {
    key: "4",
    name: "Arafat Ali",
    phoneNumber: "01704039173",
    email: "arafat@gmail.com",
    deviceType: "iOS",
    role: "Customer",
  },
  {
    key: "5",
    name: "Balvinder Singh",
    phoneNumber: "123123123",
    email: "abc@gmail.com",
    deviceType: "Android",
    role: "Store",
  },
  {
    key: "6",
    name: "Faizul Islam kallan",
    phoneNumber: "01747391455",
    email: "fikallan75@gmail.com",
    deviceType: "iOS",
    role: "Customer",
  },
  {
    key: "7",
    name: "Roony",
    phoneNumber: "9988776655",
    email: "dropmediacompany@gmail.com",
    deviceType: "Android",
    role: "Driver (Truck)",
  },
];

const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
  };

  const save = () => {
    handleSave({ ...record, [dataIndex]: inputRef.current.value });
    toggleEdit();
  };

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <div>
        <Input
          ref={inputRef}
          defaultValue={record[dataIndex]}
          onPressEnter={save}
          onBlur={save}
        />
      </div>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{ paddingRight: 24 }}
        onClick={toggleEdit}
      >
        {children}
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};

const Notification = () => {
  const { t } = useTranslation();
  const [dataSource, setDataSource] = useState(initialData);
  const [filteredData, setFilteredData] = useState(initialData);
  const [notifications, setNotifications] = useState(initialNotifications);
  const [selectedDeviceType, setSelectedDeviceType] = useState("All");
  const [selectedRole, setSelectedRole] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [currentPageNotification, setCurrentPageNotification] = useState(1);
  const [pageSizeNotification, setPageSizeNotification] = useState(5);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingNotification, setEditingNotification] = useState(null);

  const [data, setData] = useState([]);
  const [dataNotifications, setDataNotifications] = useState([]);

  const [loading, setLoading] = useState(false);
  const [loadingNotification, setLoadingNotification] = useState(false);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 8,
    total: 0,
  }); // Initial pagination settings
  const [paginationNotification, setPaginationNotification] = useState({
    current: 1,
    pageSize: 8,
  }); // Initial pagination settings

  const [searchName, setSearchName] = useState("");
  const [searchNameNotification, setSearchNameNotification] = useState("");

  const [selectedUserIds, setSelectedUserIds] = useState([]);

  const handleSave = (row) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, { ...item, ...row });
    setDataSource(newData);
  };

  const handleFilterChange = (deviceType, role) => {
    setSelectedDeviceType(deviceType);
    setSelectedRole(role);
    let filtered = dataSource;

    if (deviceType !== "All") {
      filtered = filtered.filter((item) => item.deviceType === deviceType);
    }

    if (role !== "All") {
      filtered = filtered.filter((item) => item.role === role);
    }

    setFilteredData(filtered);
  };

  // const handleTableChange = (pagination) => {
  //   setCurrentPage(pagination.current);
  //   setPageSize(pagination.pageSize);
  // };
  // const handleTableChange = (pagination) => {
  //   setCurrentPage(pagination.current);
  //   setPageSize(pagination.pageSize);
  // };
  const handleTableChange = (pagination) => {
    setPagination((prev) => ({
      ...prev,
      current: pagination.current,
      pageSize: pagination.pageSize,
    }));
  };
  const handleTableChangeNotification = (pagination) => {
    setCurrentPageNotification(pagination.current);
    setPageSizeNotification(pagination.pageSize);
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      const selectedIds = selectedRows.map((row) => row._id);
      setSelectedUserIds(selectedIds);
    },
  };

  const handleDelete = (key) => {
    const newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
  };

  const handleEditNotification = (notification) => {
    setEditingNotification(notification);
    setIsModalVisible(true);
  };

  const handleSaveNotification = (values) => {
    const newNotifications = [...notifications];
    const index = newNotifications.findIndex(
      (item) => item.key === editingNotification.key
    );
    newNotifications?.splice(index, 1, { ...editingNotification, ...values });
    setNotifications(newNotifications);
    setIsModalVisible(false);
    setEditingNotification(null);
  };

  const handleSwitchChange = (key, checked) => {
    const newNotifications = notifications.map((notification) => {
      if (notification.key === key) {
        return { ...notification, enabled: checked };
      }
      return notification;
    });
    setNotifications(newNotifications);
  };

  const fetchDataAllNotifications = async () => {
    try {
      setLoadingNotification(true);
      const params = {
        page: pagination.current,
        limit: pagination.pageSize,
        name: searchName,
      };
      const newData = await API_LIST_NOTIFICATIONS(params);
      console.log("provider", newData);
      setDataNotifications(newData);
      setLoadingNotification(false);
      setPaginationNotification({
        ...paginationNotification,
        total: newData.total_items,
      }); // Assuming API response contains total count
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const params = {
        page: pagination.current,
        limit: pagination.pageSize,
        name: searchName,
      };
      const newData = await API_LIST_USER(params);
      console.log("provider", newData);
      setData(newData);
      setLoading(false);
      setPagination((prev) => ({
        ...prev,
        total: newData.totalUsers || 0,
      }));
      // setPagination({ ...pagination, total: newData.totalUsers }); // Assuming API response contains total count
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [pagination.current, pagination.pageSize, searchName]);
  useEffect(() => {
    fetchDataAllNotifications();
  }, [
    paginationNotification.current,
    paginationNotification.pageSize,
    searchNameNotification,
  ]);

  useEffect(() => {
    handleFilterChange(selectedDeviceType, selectedRole);
  }, [dataSource]);

  console.log("user ids", selectedUserIds);
  return (
    <div>
      {/* <h2>Send Notifications</h2> */}

      <Formik
        initialValues={{ title: "", message: "" }}
        onSubmit={async (values, { setSubmitting, setFieldError, error }) => {
          console.log("values", error, values);
          if (selectedUserIds.length > 0) {
            try {
              const payload = {
                title: values?.title,
                description: values?.message,
                users: selectedUserIds,
              };

              const userData = await API_CREATE_NOTIFICATION(payload);

              toast.success(userData?.message);
              fetchDataAllNotifications();
              // Navigate("/admin/store-management/store-tables");
            } catch (error) {
              console.error("error", error);
              toast.error(error?.response?.data?.errors?.email);
            } finally {
              setSubmitting(false);
            }
          } else {
            toast.error("Please select user which you want to notify");
          }
        }}
        // onSubmit={(values) => {
        //   console.log("Form data:", values);
        // }}
      >
        {() => (
          <Form className="not">
            <Row gutter={16}>
              <Col span={24}>
                <div className="mb-3">
                  <Field
                    className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                    type="text"
                    name="title"
                    placeholder={t("Title")}
                    maxLength={20}
                    onKeyPress={(event) => {
                      const charCode = event.charCode;
                      if (
                        !(charCode >= 65 && charCode <= 90) && // A-Z
                        !(charCode >= 97 && charCode <= 122) && // a-z
                        charCode !== 32 // space
                      ) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <ErrorMessage
                    name="title"
                    component="div"
                    className="text-red-500"
                  />
                </div>
              </Col>
            </Row>
            <Row gutter={16} style={{ marginTop: 16 }}>
              <Col span={24}>
                <div className="mb-3">
                  <Field
                    className="mt-2 flex h-11 min-h-20 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                    as="textarea"
                    name="message"
                    placeholder={t("Message")}
                  />
                  <ErrorMessage
                    name="message"
                    component="div"
                    className="text-red-500"
                  />
                </div>
              </Col>
            </Row>
            <Row gutter={16} style={{ marginTop: 16 }}>
              <Col span={24}>
                <Button type="primary" htmlType="submit">
                  {t("Send Message")}
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>

      <Row
        gutter={16}
        style={{ marginBottom: 16, marginTop: 16, justifyContent: "end" }}
      >
        {/* <Col span={8}>
          <Select
            value={selectedRole}
            onChange={(value) => handleFilterChange(selectedDeviceType, value)}
            style={{ width: "100%" }}
          >
            <Option value="All">All Roles</Option>
            <Option value="Store">Store</Option>
            <Option value="Driver (Truck)">Driver (Truck)</Option>
            <Option value="Driver (Car)">Driver (Car)</Option>
            <Option value="Customer">Customer</Option>
          </Select>
        </Col> */}
        {/* <Col span={8}>
          <Select
            value={selectedDeviceType}
            onChange={(value) => handleFilterChange(value, selectedRole)}
            style={{ width: "100%" }}
          >
            <Option value="All">All Device Types</Option>
            <Option value="Android">Android</Option>
            <Option value="iOS">iOS</Option>
          </Select>
        </Col> */}
      </Row>

      <Table
        style={{ marginTop: 24 }}
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
        columns={[
          {
            title: t("Profile"),
            dataIndex: "profile",
            key: "profile",
            render: (text, record) => (
              <img
                src={
                  record?.profile_image?.[0]?.file_url
                    ? CONSTANTS?.IMG_DIRECTORY +
                      record?.profile_image?.[0]?.file_url
                    : userplace
                }
                style={{
                  width: "3rem",
                  height: "3rem",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            ),
          },
          {
            title: t("Name"),
            dataIndex: "first_name",
            key: "first_name",
            render: (text, record) =>
              record?.first_name + " " + record?.last_name,
          },
          {
            title: t("Email"),
            dataIndex: "email",
            key: "email",
          },

          {
            title: t("Phone No"),
            dataIndex: "phone_no",
            key: "phone_no",
          },
          {
            title: t("Role"),
            dataIndex: "role",
            key: "role",
          },
        ]}
        dataSource={data?.users}
        pagination={{
          current: pagination.current,
          pageSize: pagination?.pageSize,
          // total: filteredData.length,
          total: pagination?.total,
        }}
        rowKey={(record) => record._id} // Ensures the row key is _id
        onChange={handleTableChange}
        // components={{
        //   body: {
        //     cell: EditableCell,
        //   },
        // }}
      />

      <Row
        gutter={16}
        style={{ marginBottom: 16, marginTop: 16, justifyContent: "end" }}
      ></Row>

      <Table
        style={{ marginTop: 24 }}
        // rowSelection={{
        //   type: "checkbox",
        //   ...rowSelection,
        // }}
        // columns={mergedColumns}
        // dataSource={filteredData}
        columns={[
          {
            title: t("Sender"),
            dataIndex: "first_name",
            key: "first_name",
            render: (text, record) => (
              <div className="flex items-center gap-3">
                <img
                  src={
                    record?.send_from_info?.profile_image?.[0]?.file_url
                      ? CONSTANTS?.IMG_DIRECTORY +
                        record?.send_from_info?.profile_image?.[0]?.file_url
                      : userplace
                  }
                  style={{
                    width: "3rem",
                    height: "3rem",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
                <div className="flex items-center gap-3">
                  <div>{`${record?.send_from_info?.first_name} ${record?.send_from_info?.last_name}`}</div>
                  <Tag color="yellow"> {record?.send_from_info?.email}</Tag>
                </div>
              </div>
            ),
          },
          {
            title: t("Reciever"),
            dataIndex: "send_to",
            key: "send_to",
            render: (text, record) => (
              <div className="flex items-center gap-3">
                <img
                  src={
                    record?.send_to_info?.profile_image?.[0]?.file_url
                      ? CONSTANTS?.IMG_DIRECTORY +
                        record?.send_to_info?.profile_image?.[0]?.file_url
                      : userplace
                  }
                  style={{
                    width: "3rem",
                    height: "3rem",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
                <div className="flex items-center gap-3">
                  <div>{`${record?.send_to_info?.[0]?.first_name} ${record?.send_to_info?.[0]?.last_name}`}</div>
                  <Tag color="green"> {record?.send_to_info?.[0]?.email}</Tag>
                </div>
              </div>
            ),
          },

          {
            title: t("Notification Type"),
            dataIndex: "notification_type",
            key: "notification_type",
          },
        ]}
        dataSource={dataNotifications?.notifications}
        pagination={{
          current: currentPageNotification,
          pageSize: pageSizeNotification,
          total: dataNotifications?.length,
        }}
        rowKey={(record) => record._id} // Ensures the row key is _id
        onChange={handleTableChangeNotification}
        // components={{
        //   body: {
        //     cell: EditableCell,
        //   },
        // }}
      />
      {/* <h2>Previous Notifications</h2>
      <Table
        style={{ marginTop: 24 }}
        dataSource={notifications}
        // dataSource={data?.users}
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
        columns={[
          {
            title: "Title",
            dataIndex: "title",
            key: "title",
          },
          {
            title: "Message",
            dataIndex: "message",
            key: "message",
          },
          {
            title: "Enabled",
            dataIndex: "enabled",
            key: "enabled",
            render: (text, record) => (
              <Switch
                checked={record.enabled}
                onChange={(checked) => handleSwitchChange(record.key, checked)}
              />
            ),
          },
          {
            title: "Actions",
            key: "actions",
            render: (_, record) => (
              <Button
                type="link"
                onClick={() => handleEditNotification(record)}
              >
                Edit
              </Button>
            ),
          },
        ]}
        pagination={false}
        onChange={handleTableChange}

      />

      <Modal
        title="Edit Notification"
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        {editingNotification && (
          <Formik
            initialValues={{
              title: editingNotification.title,
              message: editingNotification.message,
            }}
            onSubmit={(values) => handleSaveNotification(values)}
          >
            {() => (
              <Form>
                <Row gutter={16}>
                  <Col span={24}>
                    <div className="mb-3">
                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        type="text"
                        name="title"
                        placeholder={t("Title")}
                        maxLength={20}
                        onKeyPress={(event) => {
                          const charCode = event.charCode;
                          if (
                            !(charCode >= 65 && charCode <= 90) && // A-Z
                            !(charCode >= 97 && charCode <= 122) && // a-z
                            charCode !== 32 // space
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="title"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                </Row>
                <Row gutter={16} style={{ marginTop: 16 }}>
                  <Col span={24}>
                    <div className="mb-3">
                      <Field
                        className="mt-2 flex h-11 min-h-20 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        as="textarea"
                        name="message"
                        placeholder={t("Message")}
                      />
                      <ErrorMessage
                        name="message"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                </Row>
                <Row gutter={16} style={{ marginTop: 16 }}>
                  <Col span={24}>
                    <Button type="primary" htmlType="submit">
                      Save Notification
                    </Button>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        )}
      </Modal> */}
    </div>
  );
};

export default Notification;
